import config from '../config'
import { authHeader } from './auth-header'

export const companyProfileService = {
  getAllProfiles,
  createProfile,
  updateProfile,
  deleteProfile,
  setDefaultProfile
}

function getAllProfiles () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/companyprofiles/all`, requestOptions).then(handleResponse)
}

function createProfile (profileData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(profileData)
  }
  return fetch(`${config.apiUrl}/companyprofiles/create`, requestOptions).then(handleResponse)
}

function updateProfile (profileData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(profileData)
  }
  return fetch(`${config.apiUrl}/companyprofiles/update`, requestOptions).then(handleResponse)
}

function deleteProfile (id) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  }
  return fetch(`${config.apiUrl}/companyprofiles/delete`, requestOptions).then(handleResponse)
}

function setDefaultProfile (id) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  }
  return fetch(`${config.apiUrl}/companyprofiles/setdefault`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = (data && data.Response) || (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
